import React from 'react';
import { Loader2 } from 'lucide-react';

/** Purpose: Renders activity log and note composer. Inputs: section props. Output: React render output (JSX). */
export default function ActivityLogSection({
  request,
  noteText,
  setNoteText,
  noteError,
  setNoteError,
  noteSaving,
  onAddNote
}) {
  return (
    <div className="border-t border-slate-200 pt-6">
      <h4 className="font-medium text-slate-900 mb-3">Activity Log</h4>

      <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 mb-4">
        <label className="block text-sm font-medium text-slate-700 mb-2">
          Log a note
        </label>
        <textarea
          value={noteText}
          onChange={(e) => {
            setNoteText(e.target.value);
            if (noteError) setNoteError('');
          }}
          rows={3}
          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm"
          placeholder="Document calls, follow-ups, or portal messages..."
        />
        {noteError && (
          <p className="text-xs text-red-600 mt-2">{noteError}</p>
        )}
        <div className="mt-3 flex justify-end">
          <button
            onClick={onAddNote}
            disabled={noteSaving}
            className="px-3 py-2 bg-slate-900 text-white rounded-lg text-sm hover:bg-slate-800 disabled:opacity-50 inline-flex items-center gap-2"
          >
            {noteSaving && <Loader2 className="w-4 h-4 animate-spin" />}
            Add Note
          </button>
        </div>
      </div>

      {request.communications?.length > 0 ? (
        <div className="space-y-2">
          {request.communications.map(comm => {
            const isPortal = comm.method === 'portal' || comm.createdBy === 'system';
            return (
              <div key={comm.id} className={`text-sm p-3 rounded-lg ${isPortal ? 'bg-emerald-50 border border-emerald-200' : 'bg-slate-50'}`}>
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-2">
                    <span className={`font-medium capitalize ${isPortal ? 'text-emerald-700' : 'text-slate-700'}`}>
                      {comm.type.replace('_', ' ')}
                    </span>
                    {isPortal && (
                      <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-emerald-100 text-emerald-700">
                        Portal
                      </span>
                    )}
                  </span>
                  <span className="text-slate-500">{new Date(comm.createdAt).toLocaleString()}</span>
                </div>
                {comm.content && <p className={`mt-1 ${isPortal ? 'text-emerald-600' : 'text-slate-600'}`}>{comm.content}</p>}
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-sm text-slate-500">No activity yet.</p>
      )}
    </div>
  );
}
